import {Component, Prop, Vue} from "vue-property-decorator";
import {Loading} from "element-ui";
import {setMessageReviewUserByMessageReviewId} from "@/api/message";

@Component({})
export default class ApprovedDialog extends Vue {
    @Prop() visible: false
    @Prop() data: {
        isReturn: number;
        approveId: number;
        editFiles: any;
        editFileList: any;
        isRequired: boolean;
        status: number;
        addData: object;
        // isSync: boolean; // 退款、市场费用 等是否同步
    }
    @Prop() isRefund: boolean;
    isAgreeOptions = [
        {label: '否', value: '0'},
        {label: '是', value: '1'},
    ]
    disBtn = false

    formData = {
        reviewIdea: '',
        isAgreeRevoke: '0', // 审批通过是否允许提交人撤回，默认'否'
    }

    //
    created() {
        this.formData.isAgreeRevoke = this.data.isReturn == 1 ? '1' : '0'
    }

    /*
    * methods*/
    closeReviewDialog() {
        this.formData.reviewIdea = ''
        this.formData.isAgreeRevoke = ''
        this.$emit('handleClose', false)
    }

    async confirmReviewDialog() {
        let flag = true
        const newObj = this.data.editFiles
        if (this.data.editFileList && this.data.editFileList.length > 0) {
            for (const key in newObj) {
                if (!this.data.editFileList.some(item => item.file === key)) {
                    delete newObj[key]
                }
            }
        }

        // 合作伙伴填写信息不能为空
        // const bol = this.editFileList.every(item => {
        //             if (!this.editFiles[item.file]) this.$message.error(`${item.cnFile}不能为空`)
        //             return this.editFiles[item.file]
        //         })
        //         if (!bol) return
        if (this.data.isRequired) {
            for (const key in newObj) {
                if (!newObj[key] || (newObj[key].length === 0)) {
                    this.$message.error('请将编辑的信息填写完整')
                    flag = false
                }
            }
        }

        let obj
        if (this.isRefund) {
            // 退款 this.$set(newObj, 'financeRefundProofList', this.data.addData)
            obj = {
                messageReviewId: this.data.approveId,
                status: this.data.status,
                opinion: this.formData.reviewIdea,
                form: newObj,
                isRevoke: this.formData.isAgreeRevoke,
                addData: this.data.addData, // 只有退款加
            }
        } else {
            obj = {
                messageReviewId: this.data.approveId,
                status: this.data.status,
                opinion: this.formData.reviewIdea,
                form: newObj,
                isRevoke: this.formData.isAgreeRevoke,
            }
        }

        if (flag) {
            this.$emit('doConfirm', false)
            this.disBtn = true
            const loading = Loading.service({
                text: `审批通过中，请稍后`
            })
            await setMessageReviewUserByMessageReviewId(obj).then(() => {
                this.$message.success('审批通过')
                setTimeout(() => {
                    loading.close()
                    window.close()
                }, 1500)
            }).catch((err: Error) => {
                this.disBtn = false
                setTimeout(() => {
                    loading.close()
                }, 500)
            })
        }
    }
}
